import { Pipe, PipeTransform } from '@angular/core';
import { TypesUtilsService } from '@osos/shared/legacy-core';

@Pipe({ standalone: true, name: 'propertyTranslator' })
export class PropertyTranslatorPipe implements PipeTransform {
  constructor(private typesUtilsService: TypesUtilsService) {}

  transform(query: any): string {
    return this.typesUtilsService.getLocaleString(query);
  }
}
